import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'rx-roating-arrow',
  templateUrl: './rx-roating-arrow.component.html',
  styleUrls: ['./rx-roating-arrow.component.scss'],
  imports: [CommonModule],
})
export class RxRoatingArrowComponent {
  @Input() direction: 'top' | 'bottom' | 'left' | 'right' = 'right';
  @Input() color = '#ffffff';
  @Input() size = 12;
  @Input() weight = 2;
}
